var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setor" },
    [
      _c("h3", { staticClass: "titulo" }, [_vm._v(_vm._s(_vm.titulo))]),
      _c(
        "el-row",
        { staticClass: "pesquisa", attrs: { gutter: 12 } },
        [
          _c("el-col", { attrs: { lg: 8, md: 9, sm: 24 } }, [
            _c("p", { staticClass: "label" }, [_vm._v("Selecionar período:")]),
            _c(
              "form",
              [
                _c(
                  "el-date-picker",
                  _vm._b(
                    {
                      staticClass: "full-width input",
                      attrs: {
                        type: "daterange",
                        "unlink-panels": "unlink-panels",
                        placeholder: "Selecione",
                        "range-separator": "a",
                        format: "dd/MM/yyyy",
                        "start-placeholder": "Data inicial",
                        "end-placeholder": "Data final",
                        name: "prazo",
                        "picker-options": _vm.options,
                        clearable: false
                      },
                      model: {
                        value: _vm.filtro.dateRange,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "dateRange", $$v)
                        },
                        expression: "filtro.dateRange"
                      }
                    },
                    "el-date-picker",
                    _vm.$attrs,
                    false
                  )
                )
              ],
              1
            )
          ]),
          !_vm.isRR
            ? _c(
                "el-col",
                { attrs: { lg: 6, md: 5, sm: 24 } },
                [
                  _c("p", { staticClass: "label" }, [_vm._v("Município:")]),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width input",
                      attrs: {
                        filterable: "filterable",
                        multiple: "multiple",
                        planceholder: "Selecione",
                        "no-match-text": "Nenhum município encontrado",
                        name: "municipio",
                        "collapse-tags": "collapse-tags",
                        clearable: false
                      },
                      model: {
                        value: _vm.filtro.municipios,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "municipios", $$v)
                        },
                        expression: "filtro.municipios"
                      }
                    },
                    _vm._l(_vm.municipiosPA, function(municipio) {
                      return _c("el-option", {
                        key: municipio.id,
                        attrs: { label: municipio.nome, value: municipio.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          !_vm.isRR
            ? _c(
                "el-col",
                { attrs: { lg: 6, md: 5, sm: 24 } },
                [
                  _c("p", { staticClass: "label" }, [_vm._v("Perfil:")]),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width input",
                      attrs: {
                        filterable: "filterable",
                        multiple: "multiple",
                        planceholder: "Selecione",
                        "no-match-text": "Nenhum perfil encontrado",
                        "collapse-tags": "collapse-tags",
                        name: "perfil",
                        clearable: false
                      },
                      model: {
                        value: _vm.filtro.perfis,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "perfis", $$v)
                        },
                        expression: "filtro.perfis"
                      }
                    },
                    _vm._l(_vm.perfis, function(perfil) {
                      return _c("el-option", {
                        key: perfil.codigo,
                        attrs: { label: perfil.nome, value: perfil.codigo }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          !_vm.isRR
            ? _c(
                "el-col",
                { attrs: { lg: 4, md: 5, sm: 24 } },
                [
                  _c("p", { staticClass: "label" }, [_vm._v("Ações:")]),
                  _c(
                    "el-select",
                    {
                      staticClass: "full-width input",
                      attrs: {
                        filterable: "filterable",
                        multiple: "multiple",
                        planceholder: "Selecione",
                        "no-match-text": "Nenhuma ação encontrada",
                        "collapse-tags": "collapse-tags",
                        name: "acao",
                        clearable: false
                      },
                      model: {
                        value: _vm.filtro.acoes,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "acoes", $$v)
                        },
                        expression: "filtro.acoes"
                      }
                    },
                    _vm._l(_vm.acoes, function(acao) {
                      return _c("el-option", {
                        key: acao.codigo,
                        attrs: { label: acao.nome, value: acao.codigo }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("el-row", [
        _c(
          "div",
          { staticClass: "button-pesquisar" },
          [
            _c(
              "el-button",
              {
                staticClass: "margin-button",
                attrs: { type: "text" },
                on: { click: _vm.limparPesquisa }
              },
              [_vm._v(" Limpar filtro")]
            ),
            _c(
              "el-button",
              {
                staticClass: "margin-button",
                attrs: { type: "primary" },
                on: { click: _vm.pesquisar }
              },
              [
                _c("i", { staticClass: "icon fa fa-search" }),
                _vm._v(" Pesquisar")
              ]
            )
          ],
          1
        )
      ]),
      _c("el-row", { staticClass: "margin", attrs: { gutter: 10 } }, [
        _vm.hasDados
          ? _c(
              "div",
              [
                _c(
                  "el-col",
                  { staticClass: "width-100", attrs: { sm: 24 } },
                  [
                    _c(
                      "el-card",
                      { staticClass: "box-card", attrs: { shadow: "hover" } },
                      [
                        _vm._t("header", [
                          _c("h3", [_vm._v("Produtividade do setor")])
                        ]),
                        _c(
                          "div",
                          [
                            _c("grafico-processo-por-analista", {
                              attrs: {
                                dadosLabels:
                                  _vm.produtividade.produtividadeServidores,
                                filtro: _vm.filtro
                              },
                              on: {
                                produtividadePorAnalista:
                                  _vm.produtividadePorAnalista
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                ),
                !_vm.isRR
                  ? _c(
                      "el-col",
                      { attrs: { lg: 24, md: 24 } },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass: "box-card",
                            attrs: { shadow: "hover" }
                          },
                          [
                            _vm._t("header", [
                              _c("h3", [
                                _vm._v("Produtividade dos servidores do setor")
                              ])
                            ]),
                            _c(
                              "div",
                              [
                                _c("grafico-produtividade", {
                                  attrs: {
                                    dadosLabels:
                                      _vm.produtividade.produtividadeServidores
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isRR
                  ? _c(
                      "el-col",
                      { attrs: { lg: 24, md: 24 } },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass: "box-card",
                            attrs: { shadow: "hover" }
                          },
                          [
                            _vm._t("header", [
                              _c("h3", [
                                _vm._v("Quantidade de processos por tipo")
                              ])
                            ]),
                            _c(
                              "div",
                              { staticClass: "teste" },
                              [
                                _c("grafico-quantidade-processo", {
                                  attrs: {
                                    dadosLabels:
                                      _vm.produtividade.processosPorTipo
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isRR
                  ? _c(
                      "el-col",
                      { staticClass: "width-100", attrs: { sm: 24 } },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass: "box-card",
                            attrs: { shadow: "hover" }
                          },
                          [
                            _vm._t("header", [
                              _c("h3", [_vm._v("Produtividade por período")])
                            ]),
                            _c(
                              "div",
                              [
                                _c("grafico-rendimento", {
                                  attrs: {
                                    dadosLabels: _vm.produtividade
                                      .produtividadePeriodoAnoMes
                                      ? _vm.produtividade
                                          .produtividadePeriodoAnoMes
                                      : _vm.produtividade
                                          .produtividadePeriodoAnoMesDia,
                                    filtro: _vm.filtro,
                                    isProdutividadePeriodoAnoMes: _vm
                                      .produtividade.produtividadePeriodoAnoMes
                                      ? true
                                      : false
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isRR
                  ? _c(
                      "el-col",
                      { staticClass: "width-100", attrs: { sm: 24 } },
                      [
                        _c(
                          "div",
                          { staticClass: "container-map" },
                          [
                            !_vm.isLoading
                              ? _c("mapa-processos", {
                                  attrs: {
                                    dadosLabels:
                                      _vm.produtividade
                                        .produtividadeProcessoLocalizacao
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.isRR && _vm.produtividade.processosAnalisados
                  ? _c(
                      "el-col",
                      { staticClass: "width-100", attrs: { sm: 24 } },
                      [
                        _vm.showModal
                          ? _c("app-modal-visualizar-completo", {
                              attrs: {
                                showModal: _vm.showModal,
                                idProcesso: _vm.idProcesso,
                                protocolo: _vm.protocolo,
                                numeroProcesso: _vm.numeroProcesso,
                                tipo: _vm.tipoProcesso
                              },
                              on: {
                                closeModal: function($event) {
                                  _vm.showModal = false
                                }
                              }
                            })
                          : _vm._e(),
                        _c(
                          "el-card",
                          {
                            staticClass: "box-card",
                            attrs: { shadow: "hover" }
                          },
                          [
                            _vm._t("header", [
                              _c("h3", [_vm._v("Processos analisados")])
                            ]),
                            _c(
                              "el-table",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.loading,
                                    expression: "loading"
                                  }
                                ],
                                attrs: {
                                  data:
                                    _vm.produtividade.processosAnalisados
                                      .content,
                                  "element-loading-text": "Carregando..."
                                },
                                on: { "sort-change": _vm.sort }
                              },
                              [
                                _c("template", { slot: "empty" }, [
                                  _vm._v("Não há registros.")
                                ]),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "numeroProcesso",
                                    label: "Processo",
                                    width: "auto",
                                    sortable: "sortable"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "setor",
                                    label: "Setor",
                                    width: "auto",
                                    sortable: "sortable"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "nomeRazaoSocialInteressado",
                                    label: "Nome do interessado",
                                    width: "auto",
                                    sortable: "sortable"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "nomeRazaoSocialUsuario",
                                    label: "Técnico responsável",
                                    width: "auto",
                                    sortable: "sortable"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "tipo",
                                    label: "Tipo de processo",
                                    width: "auto",
                                    sortable: "sortable"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "municipio",
                                    label: "Município",
                                    width: "auto",
                                    sortable: "sortable"
                                  }
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    label: "Ações",
                                    width: "120",
                                    align: "center"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "el-dropdown",
                                              { attrs: { trigger: "click" } },
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      type: "primary",
                                                      size: "small"
                                                    }
                                                  },
                                                  [
                                                    _vm._v("Ações"),
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-arrow-down el-icon--right"
                                                    })
                                                  ]
                                                ),
                                                _c(
                                                  "el-dropdown-menu",
                                                  {
                                                    attrs: { slot: "dropdown" },
                                                    slot: "dropdown"
                                                  },
                                                  [
                                                    _c("el-dropdown-item", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "flex",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.abreModal(
                                                                scope.row
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-eye"
                                                          }),
                                                          _vm._v(
                                                            "  Visualizar processo"
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3640750862
                                  )
                                })
                              ],
                              2
                            ),
                            _c(
                              "div",
                              { staticClass: "pagination" },
                              [
                                _c("app-paginacao", {
                                  attrs: {
                                    total:
                                      _vm.produtividade.processosAnalisados
                                        .totalElements,
                                    pagina: _vm.currentPage,
                                    tamanhoPagina: 15
                                  },
                                  on: { changePage: _vm.changePage }
                                })
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          : _c("div", { staticClass: "flex" }, [
              _c("div", { staticClass: "border-top-bottom" }, [
                _c("span", { staticClass: "cinza" }, [
                  _vm._v("Não existem resultados para serem exibidos.")
                ])
              ])
            ])
      ]),
      _c(
        "div",
        { staticClass: "margin" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn",
              attrs: { type: "default" },
              on: {
                click: function($event) {
                  return _vm.voltar()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-chevron-left" }), _vm._v("  Voltar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0274834d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0274834d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/produtividade/ProdutividadeSetor.vue
// module id = null
// module chunks = 